import * as THREE from "three";
import {NetworkNode, RouterNetworkTree} from "../../../../../../../services/back/infrastructure-schema.service";
import {Line} from "../../Shapes/Line";
import {RoutersManager} from "../Router/ManagerGeneralRouter";
import {NetworkZone} from "../../Shapes/NetworkZone";
import {Disk} from "../../Shapes/Disk";
import {LineCurved} from "../../Shapes/LineCurved";
import {levelArray} from "../ManagerLevel";
import {ConnectedNetworkOutput} from "../../System/GlobalSizing";

export function IntercommunicationNetwork(
	scene: THREE.Scene,
	x: number,
	z: number,
	dataguide: ConnectedNetworkOutput[],
	intercoNetworks: NetworkNode[],
): void {

	let newZ: number = levelArray[intercoNetworks[0].connectedRouters[0].depth] - 8

	switch (intercoNetworks.length) {
		case 1:
			Line(scene, x, z, x, newZ + 2)
			IntercoZone(scene, x, newZ + 2, intercoNetworks[0], dataguide[0])
			break
		case 2:
			Line(scene, x, z, x, newZ + 2);
			LineCurved(scene, x, newZ, 1, "SE");
			GeneralInterco(scene, x, newZ,  intercoNetworks, dataguide)
			break
		default:
			Line(scene, x, z, x, newZ + 2);
			LineCurved(scene, x, newZ, 1, "SW");
			LineCurved(scene, x, newZ, 1, "SE");
			GeneralInterco(scene, x, newZ, intercoNetworks, dataguide)
			break
	}
}

function GeneralInterco(
	scene: THREE.Scene,
	x: number,
	z: number,
	intercoNetworks: NetworkNode[],
	dataguide: ConnectedNetworkOutput[],
) :void {

	IntercoZone(scene, x, z + 2, intercoNetworks[0], dataguide[0]) // i = 0

	if ((intercoNetworks.length - 1) % 2 === 0 ) {
		RightInterco(scene, x, z, intercoNetworks, dataguide, 1)
		LeftInterco(scene, x, z, intercoNetworks, dataguide, (intercoNetworks.length /2 + .5))
	} else {
		RightInterco(scene, x, z, intercoNetworks, dataguide, 1)
		LeftInterco(scene, x, z, intercoNetworks, dataguide, ((intercoNetworks.length) /2))
	}
}

function RightInterco(
	scene: THREE.Scene,
	x: number,
	z: number,
	intercoNetworks: NetworkNode[],
	dataguide: ConnectedNetworkOutput[],
	i: number,
): void {

	if (i <= (intercoNetworks.length-1)/2) {

		const backOffset: number = dataguide[i-1].maxRight
		const frontOffset: number = -dataguide[i].maxLeft //- 2

		Line(scene, x + 1, z + 1, x + backOffset + frontOffset - 1, z + 1)
		LineCurved(scene, x + backOffset + frontOffset - 1, z + 1, 1, "WS")
		if (i>1) {
			Line(scene, x - 1, z + 1, x+1, z + 1)
		}
		IntercoZone(scene, x + backOffset + frontOffset, z + 2, intercoNetworks[i], dataguide[i])

		// Récursivité
		RightInterco(scene, x + backOffset + frontOffset, z, intercoNetworks, dataguide, i + 1)
	}
}

function LeftInterco(
	scene: THREE.Scene,
	x: number,
	z: number,
	intercoNetworks: NetworkNode[],
	dataguide: ConnectedNetworkOutput[],
	i: number,
): void {

	if ( i < intercoNetworks.length ) {
		let backOffset: number;

		// Calcule du nombre d'écarts avec les routers suivant
		if (i==(intercoNetworks.length/2)+.5 || i==(intercoNetworks.length/2)) {
			backOffset = -dataguide[0].maxLeft
		} else {
			backOffset = -dataguide[i].maxLeft
		}

		const frontOffset: number = dataguide[i].maxRight //- 2

		Line(scene, x-1, z+1, x - backOffset - frontOffset + 1, z + 1)
		LineCurved(scene, x - backOffset - frontOffset + 1, z + 1, 1, "ES")
		if (i > (intercoNetworks.length/2)+.5) {
			Line(scene, x + 1, z + 1, x-1, z + 1)
		}
		IntercoZone(scene, x - backOffset - frontOffset, z + 2, intercoNetworks[i], dataguide[i])

		// Récursivité
		LeftInterco(scene, x - backOffset - frontOffset, z, intercoNetworks, dataguide, i + 1)
	}
}

function IntercoZone(
	scene: THREE.Scene,
	x: number,
	z: number,
	intercoNetworks: NetworkNode,
	dataguide: ConnectedNetworkOutput,
): void {

	const blancColor = 0xffffff;
	const roseColor = 0xA890F3;
	const violetColor = 0xA890F3;

	const newZ = z + 2
	const zoneName: string = intercoNetworks.network.network.name
	const zoneHeight: number = 2
	let zoneWidth: number = 14

	Line(scene, x, z, x, newZ)
	Disk(scene, x, newZ, 0.2, blancColor, violetColor);
	NetworkZone(scene, x, newZ, zoneWidth, zoneHeight, 0.5, roseColor, violetColor, 0.01, zoneName, intercoNetworks.network.network.id);
	Disk(scene, x, newZ + zoneHeight, 0.2, blancColor, violetColor);

	RoutersManager(scene, x, newZ + zoneHeight, intercoNetworks.connectedRouters, dataguide.connectedRouters)
}
